module.exports = __webpack_public_path__ + "img/37_22.c0192518.png";